import Publications from './publications';

export default Publications;
